module.exports = __webpack_public_path__ + "img/8.70e71ec1.png";